/**
 * View component for /admin/authoring/sites/new
 *
 * Creates a new site from a copy of the defaultItem in the site reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as siteActions from '../siteActions';
import * as siteLocationActions from '../../siteLocation/siteLocationActions';
import * as sponsorActions from '../../sponsor/sponsorActions';
import * as studyActions from '../../study/studyActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';

// import site components
import SiteForm from '../components/SiteForm.js.jsx';

class AdminCreateSite extends Base {
  constructor(props) {
    super(props);
    this.state = {
      site: { ...this.props.defaultSite }
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(sponsorActions.fetchListIfNeeded("all"));
    dispatch(siteLocationActions.fetchListIfNeeded("all"));
  }

  _handleFormChange(e) {
    const { dispatch } = this.props;
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newSiteState = _.update( this.state.site, e.target.name, function() {
      return e.target.value;
    });
    this.setState({site: newSiteState});
    if(e.target.name === "_organization") {
      dispatch(studyActions.fetchListIfNeeded("_organization", e.target.value));
    }
  }


  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(siteActions.sendCreateSite(this.state.site)).then((action) => {
      if(action.success) {
        dispatch(siteActions.invalidateList());
        history.push(`/admin/authoring/sites/${action.item._id}`);
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert(`ERROR: ${action.error}`);
      }
    });
  }

  render() {
    const { site } = this.state;
    const { siteLocationStore, sponsorStore, studyStore } = this.props;
    const siteLocations = siteLocationStore.util.getList() || [];
    const sponsors = sponsorStore.util.getList() || [];
    const studies = studyStore.util.getList("_organization", site._organization) || [];
    const isEmpty = (site.name === null || site.name === undefined);
    return (
      <div className="flex">
        <Helmet
          title={"Create Site | Pro-ficiency"}
        />
        <section className="section">
          <div className="yt-container">
            <Breadcrumbs links={location.state.breadcrumbs} />
          </div>
          { isEmpty ?
              <h2> Loading...</h2>
            :
            <div>
              <h2>Create a new site for the following program</h2>
              <p><strong>Program: </strong>{studyStore.byId[site._group] && studyStore.byId[site._group].name}</p>
              <p><strong>Sponsor: </strong>{sponsorStore.byId[site._organization] && sponsorStore.byId[site._organization].name}</p>
              <SiteForm
                cancelLink="/admin/sites"
                formTitle=""
                formType="create"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
                site={site}
                siteLocations={siteLocations}
                sponsors={sponsors}
                studies={studies}
              />
            </div>
          }
        </section>
      </div>
    )
  }
}

AdminCreateSite.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultSite: store.site.defaultItem
    , siteLocationStore: store.siteLocation
    , sponsorStore: store.sponsor
    , studyStore: store.study
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminCreateSite)
);



// WEBPACK FOOTER //
// modules/site/views/AdminCreateSite.js.jsx